import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

export type AddressDataType = {
  guid: string;
  address?: {
    addressType: string;
    address1: string;
    address2: string;
    zipCode: string;
    city: string;
    state: string;
    notes?: {
      type: string;
      value?: string;
    }[];
    addressId: string;
  };
  fulfillmentType?: {
    preferenceDefId: string;
    value: string;
  };
  slotPreference: {
    slotId?: string;
    preferenceDefId: string;
    slotType: string;
    fulfillmentDay: string;
    slotStartTS: string;
    slotEndTS: string;
  };
  store?: {
    storeId: string;
    banner: string;
  };
};

function saveAddressService(environmentVariables, user, addressData: AddressDataType) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_PATCH_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).patch(
    formatString(get(environmentVariables, 'SNS_SAVE_ADDRESS', 'save_address'), {
      UUID: get(user, 'UUID'),
    }),
    addressData,
  );
}

export default saveAddressService;
